import update from 'immutability-helper';
import { CreateDeviceActions, CreateDeviceActionsType } from './action';

type InitialStateType = {
  userLocation: {
    lat: number;
    lon: number;
  };
  deviceLocation: {
    lat: number;
    lon: number;
  };
  isCreateDeviceModalOpen: boolean;
  isLocationPopUpOpen: boolean;
  organization: string;
  address: string;
  notes: string;
  isValidInput: boolean;
  errorText: string;
  isLoading: boolean;
  distanceErrorMessage: string;
  errorMessage: string;
};

export const initialState: InitialStateType = {
  userLocation: {
    lat: 0,
    lon: 0,
  },
  deviceLocation: {
    lat: 0,
    lon: 0,
  },
  isCreateDeviceModalOpen: false,
  isLocationPopUpOpen: false,
  organization: '',
  address: '',
  notes: '',
  isValidInput: false,
  errorText: '',
  isLoading: false,
  distanceErrorMessage: '',
  errorMessage: '',
};

export function createDeviceReducer(state: InitialStateType = initialState, action: CreateDeviceActionsType) {
  switch (action.type) {
    case CreateDeviceActions.SET_GEOLOCATION:
      return update(state, {
        userLocation: {
          lat: { $set: action.userLocation.lat },
          lon: { $set: action.userLocation.lon },
        },
      });
    case CreateDeviceActions.OPEN_CREATE_MODAL:
      return update(state, {
        deviceLocation: {
          lat: { $set: action.deviceLocation.lat },
          lon: { $set: action.deviceLocation.lon },
        },
        isCreateDeviceModalOpen: { $set: true },
      });
    case CreateDeviceActions.CLOSE_CREATE_MODAL:
      return update(state, {
        isCreateDeviceModalOpen: { $set: false },
      });
    case CreateDeviceActions.SHOW_LOCATION_POPUP:
      return update(state, {
        deviceLocation: {
          lat: { $set: action.deviceLocation.lat },
          lon: { $set: action.deviceLocation.lon },
        },
        isLocationPopUpOpen: { $set: true },
        address: { $set: action.address },
        distanceErrorMessage: { $set: '' },
      });
    case CreateDeviceActions.HIDE_LOCATION_POPUP:
      return update(state, {
        isLocationPopUpOpen: { $set: false },
        distanceErrorMessage: { $set: '' },
      });
    case CreateDeviceActions.ON_ORGANIZATION_CHANGE:
      const { organization } = action;
      if (organization.length > 0) {
        return update(state, {
          isValidInput: { $set: true },
          organization: { $set: action.organization },
          errorText: { $set: '' },
        });
      }
      return update(state, {
        isValidInput: { $set: false },
        organization: { $set: '' },
        errorText: { $set: 'Обязательное поле' },
      });
    case CreateDeviceActions.ON_ADDRESS_CHANGE:
      return update(state, {
        address: { $set: action.address },
      });
    case CreateDeviceActions.ON_NOTES_CHANGE:
      return update(state, {
        notes: { $set: action.notes },
      });
    case CreateDeviceActions.CREATE_DEVICE_REQUEST:
      return update(state, {
        isLoading: { $set: true },
      });
    case CreateDeviceActions.CREATE_DEVICE_SUCCEEDED:
      return update(state, {
        isLoading: { $set: false },
        isCreateDeviceModalOpen: { $set: false },
      });
    case CreateDeviceActions.CREATE_DEVICE_FAILED:
      return update(state, {
        isLoading: { $set: false },
        errorMessage: { $set: action.errorMessage },
      });
    case CreateDeviceActions.SHOW_DISTANCE_ERROR:
      return update(state, {
        distanceErrorMessage: { $set: `Вы слишком далеко!Нужно быть не дальше 50 м.` },
      });
    default:
      return state;
  }
}
